import { config } from '@fortawesome/fontawesome-svg-core';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setupChunkErrorRecovery } from './lib/utils/chunkErrorRecovery';
import { initDatadogRum } from './lib/utils/datadog';
import { showDevtools } from './lib/utils/env';
import { initIntercom } from './lib/utils/intercom';
import { queryClient } from './lib/utils/queryClient';
import { router } from './lib/utils/router';
import './lib/utils/i18n';
import './styles/globals.css';

// FontAwesome renders inline SVGs; the core CSS is imported (layered) in
// globals.css. Disable the
// runtime <style> auto-injection so nothing is added dynamically (CSP-safe).
config.autoAddCss = false;

initDatadogRum();
initIntercom();
setupChunkErrorRecovery();

const rootElement = document.getElementById('root')!;

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* Bottom-left, with the router devtools: the right edge belongs to the
          Intercom bubble and its dismiss ✕, and a right-side sheet covers that
          corner anyway. This one sits in the corner proper — the router button
          takes the 4.25rem offset above it, as it did on the right. */}
      {showDevtools && <ReactQueryDevtools buttonPosition='bottom-left' />}
    </QueryClientProvider>
  </StrictMode>,
);
